import React from 'react';

export default class MenuContacts extends React.PureComponent {
  render() {
    return (
      <div className="menu-contacts-bar">
        {this.props.onDialpad ?
          <>
            <a href="#" title="Keypad Dialer (12-Digit ICN)" onClick={(e) => {e.preventDefault(); this.props.onDialpad();}}><i className="material-icons">dialpad</i></a>
            &nbsp;
          </> : null}
        <a href="#" title="New Chat / Create Group" onClick={(e) => {e.preventDefault(); this.props.onNewTopic();}}><i className="material-icons">chat</i></a>
        &nbsp;
        <a href="#" title="Settings" aria-label="Settings"
          onClick={(e) => {e.preventDefault(); this.props.onSettings();}}><i className="material-icons">settings</i></a>
        &nbsp;
      </div>
    );
  }
};
